import React from "react"

export default () => {
  return (
    <svg
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="instagram">
        <g id="Group">
          <g id="Group">
            <path
              d="M31.25 0L68.75 0C86.0062 0 100 13.9938 100 31.25L100 68.75C100 86.0062 86.0062 100 68.75 100L31.25 100C13.9938 100 0 86.0062 0 68.75L0 31.25C0 13.9938 13.9938 0 31.25 0ZM68.75 90.625C80.8125 90.625 90.625 80.8125 90.625 68.75L90.625 31.25C90.625 19.1875 80.8125 9.375 68.75 9.375L31.25 9.375C19.1875 9.375 9.375 19.1875 9.375 31.25L9.375 68.75C9.375 80.8125 19.1875 90.625 31.25 90.625L68.75 90.625Z"
              id="Shape"
              fill="#000000"
              fillRule="evenodd"
              stroke="none"
            />
          </g>
        </g>
        <g id="Group" transform="translate(25 25)">
          <g id="Group">
            <path
              d="M0 25C0 11.1938 11.1938 0 25 0C38.8063 0 50 11.1938 50 25C50 38.8063 38.8063 50 25 50C11.1938 50 0 38.8063 0 25ZM9.375 25C9.375 33.6125 16.3875 40.625 25 40.625C33.6125 40.625 40.625 33.6125 40.625 25C40.625 16.3813 33.6125 9.375 25 9.375C16.3875 9.375 9.375 16.3813 9.375 25Z"
              id="Shape"
              fill="#000000"
              fillRule="evenodd"
              stroke="none"
            />
          </g>
        </g>
        <g id="Group" transform="translate(73.54376 19.79376)">
          <g id="Group">
            <path
              d="M0 3.33125C0 1.49145 1.49145 0 3.33125 0C5.17105 0 6.6625 1.49145 6.6625 3.33125C6.6625 5.17105 5.17105 6.6625 3.33125 6.6625C1.49145 6.6625 0 5.17105 0 3.33125Z"
              id="Circle"
              fill="#000000"
              stroke="none"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
